import { AxiosError, AxiosResponse } from 'axios';
import {
    FERTILIZER_EVENTS_LOAD_CANCELED,
    FERTILIZER_EVENTS_LOAD_FAILED,
    FERTILIZER_EVENTS_LOAD_REQUESTED,
    FERTILIZER_EVENTS_LOAD_SUCCEEDED,
    FERTILIZER_EVENT_CREATE_FAILED,
    FERTILIZER_EVENT_CREATE_REQUESTED,
    FERTILIZER_EVENT_CREATE_SUCCEEDED,
    FERTILIZER_EVENT_DELETE_FAILED,
    FERTILIZER_EVENT_DELETE_REQUESTED,
    FERTILIZER_EVENT_DELETE_SUCCEEDED,
    FERTILIZER_EVENT_SET,
    FERTILIZER_EVENTS_SET,
    FERTILIZER_EVENT_UPDATE_FAILED,
    FERTILIZER_EVENT_UPDATE_REQUESTED,
    FERTILIZER_EVENT_UPDATE_SUCCEEDED,
    FERTILIZER_EVENTS_COMPLETE_FAILED,
    FERTILIZER_EVENTS_COMPLETE_REQUESTED,
    FERTILIZER_EVENTS_COMPLETE_SUCCEEDED
} from './constants';
import {
    CanceledLoadFertilizerEventsAction,
    FailedLoadFertilizerEventsAction,
    FertilizerEvent,
    FertilizerEventUuid,
    RequestLoadFertilizerEventsAction,
    SucceededLoadFertilizerEventsAction,
    FailedCreateFertilizerEventAction,
    RequestCreateFertilizerEventAction,
    RequestCreateFertilizerEventPayload,
    SucceededCreateFertilizerEventAction,
    SetFertilizerEventAction,
    SetFertilizerEventsAction,
    FailedUpdateFertilizerEventAction,
    RequestUpdateFertilizerEventAction,
    RequestUpdateFertilizerEventPayload,
    SucceededUpdateFertilizerEventAction,
    RequestDeleteFertilizerEventAction,
    SucceededDeleteFertilizerEventAction,
    FailedDeleteFertilizerEventAction,
    RequestCompleteFertilizerEventsAction,
    SucceededCompleteFertilizerEventsAction,
    FailedCompleteFertilizerEventsAction
} from './types';

export function setFertilizerEvent(
    payload: Record<FertilizerEventUuid, FertilizerEvent>
): SetFertilizerEventAction {
    return {
        type: FERTILIZER_EVENT_SET,
        payload
    };
}

export function setFertilizerEvents(
    payload: Record<FertilizerEventUuid, FertilizerEvent>
): SetFertilizerEventsAction {
    return {
        type: FERTILIZER_EVENTS_SET,
        payload
    };
}

export function succeededUpdateFertilizerEvent(
    payload: AxiosResponse
): SucceededUpdateFertilizerEventAction {
    return {
        type: FERTILIZER_EVENT_UPDATE_SUCCEEDED,
        payload
    };
}

export function failedUpdateFertilizerEvent(
    payload: AxiosError
): FailedUpdateFertilizerEventAction {
    return {
        type: FERTILIZER_EVENT_UPDATE_FAILED,
        payload,
        error: true
    };
}

export function requestUpdateFertilizerEvent(
    payload: RequestUpdateFertilizerEventPayload
): RequestUpdateFertilizerEventAction {
    return {
        type: FERTILIZER_EVENT_UPDATE_REQUESTED,
        payload
    };
}

export function requestCreateFertilizerEvent(
    payload: RequestCreateFertilizerEventPayload
): RequestCreateFertilizerEventAction {
    return {
        type: FERTILIZER_EVENT_CREATE_REQUESTED,
        payload
    };
}

export function succeededCreateFertilizerEvent(
    payload: AxiosResponse
): SucceededCreateFertilizerEventAction {
    return {
        type: FERTILIZER_EVENT_CREATE_SUCCEEDED,
        payload
    };
}

export function failedCreateFertilizerEvent(
    payload: AxiosError
): FailedCreateFertilizerEventAction {
    return {
        type: FERTILIZER_EVENT_CREATE_FAILED,
        payload,
        error: true
    };
}

export function requestLoadFertilizerEvents(): RequestLoadFertilizerEventsAction {
    return {
        type: FERTILIZER_EVENTS_LOAD_REQUESTED
    };
}

export function succeededLoadFertilizerEvents(
    fertilizerEvents: Record<FertilizerEventUuid, FertilizerEvent>
): SucceededLoadFertilizerEventsAction {
    return {
        type: FERTILIZER_EVENTS_LOAD_SUCCEEDED,
        payload: fertilizerEvents
    };
}

export function failedLoadFertilizerEvents(
    error: AxiosError
): FailedLoadFertilizerEventsAction {
    return {
        type: FERTILIZER_EVENTS_LOAD_FAILED,
        payload: error,
        error: true
    };
}

export function cancelLoadFertilizerEvents(): CanceledLoadFertilizerEventsAction {
    return {
        type: FERTILIZER_EVENTS_LOAD_CANCELED
    };
}

export function requestDeleteFertilizerEvent(
    payload: FertilizerEventUuid[]
): RequestDeleteFertilizerEventAction {
    return {
        type: FERTILIZER_EVENT_DELETE_REQUESTED,
        payload
    };
}

export function succeededDeleteFertilizerEvent(
    payload: FertilizerEventUuid[]
): SucceededDeleteFertilizerEventAction {
    return {
        type: FERTILIZER_EVENT_DELETE_SUCCEEDED,
        payload
    };
}

export function failedDeleteFertilizerEvent(
    payload: AxiosError
): FailedDeleteFertilizerEventAction {
    return {
        type: FERTILIZER_EVENT_DELETE_FAILED,
        payload,
        error: true
    };
}

export function requestCompleteFertilizerEvents(
    payload: FertilizerEventUuid[]
): RequestCompleteFertilizerEventsAction {
    return {
        type: FERTILIZER_EVENTS_COMPLETE_REQUESTED,
        payload
    };
}

export function succeededCompleteFertilizerEvents(
    payload: AxiosResponse
): SucceededCompleteFertilizerEventsAction {
    return {
        type: FERTILIZER_EVENTS_COMPLETE_SUCCEEDED,
        payload
    };
}

export function failedCompleteFertilizerEvents(
    payload: AxiosError
): FailedCompleteFertilizerEventsAction {
    return {
        type: FERTILIZER_EVENTS_COMPLETE_FAILED,
        payload,
        error: true
    };
}
